function showMore() {
  const list = document.getElementById('commentList');
  const moreButton = document.getElementById('js-button-more');
  for (let i = 0; i < list.children.length; i++) {
    if (i >= 5) {
      // console.log(list.children[i]);
      list.children[i].classList.add('is-hide');
      moreButton.classList.remove('is-hide');
    } else {
      moreButton.classList.add('is-hide');
    }
  }

  moreButton.addEventListener('click', function (event) {
    for (let i = 0; i < list.children.length; i++) {
      if (list.children[i].classList.contains('is-hide')) {
        list.children[i].classList.remove('is-hide');
        moreButton.textContent = `閉じる`;
        moreButton.classList.add('active');
      } else {
        if (i >= 5) {
          // console.log(list.children[i]);
          list.children[i].classList.add('is-hide');
          moreButton.textContent = `もっと見る`;
          moreButton.classList.remove('active');
        }
      }
    }
    event.preventDefault();
  });
}

showMore();
